import type { LeaveType } from "./leaveCalendar.types";

/**
 * Shared leave-type → colour mapping. Single source of truth for the company
 * leave calendar (LeaveCalendarUserRow) and any other view that paints leave
 * days the same way (e.g. the employee card's wall calendar).
 */

/** Solid glass-style background per leave type — approved leave cells. */
export const LEAVE_TYPE_BG: Record<LeaveType, string> = {
  vacation:
    "bg-emerald-500/85 backdrop-blur-sm shadow-sm shadow-emerald-100/50",
  business_trip: "bg-sky-500/85 backdrop-blur-sm shadow-sm shadow-sky-100/50",
  remote_work:
    "bg-indigo-500/85 backdrop-blur-sm shadow-sm shadow-purple-100/50",
};

export const LEAVE_TYPE_BORDER: Record<LeaveType, string> = {
  vacation: "border-emerald-400/20",
  business_trip: "border-sky-400/20",
  remote_work: "border-indigo-400/20",
};

export const LEAVE_TYPE_TEXT: Record<LeaveType, string> = {
  vacation: "text-white",
  business_trip: "text-white",
  remote_work: "text-white",
};

/** Single-letter chip shown inside a leave cell (V = vacation-family, K = business trip, R = remote work). */
export const LEAVE_TYPE_LABEL: Record<LeaveType, string> = {
  vacation: "V",
  business_trip: "K",
  remote_work: "R",
};

/** Pending-approval cells use this amber fill instead of the type colour. */
export const LEAVE_PENDING_BG =
  "bg-amber-400/85 backdrop-blur-sm border-amber-300/35 text-slate-800 shadow-sm shadow-amber-100";
export const LEAVE_PENDING_TEXT = "text-slate-800";
